import { createModuleStore } from '../utils'

export const usePickListsStore = createModuleStore(
  'pick-lists',
  {
    type: 'Pick List',
    pageHeading: 'Pick Lists',
    noHistory: true,
    noCopy: true,
    emitItems: true,
    sortingOn: 'toolbar',
    uploadOptionsCsv: '',
    uri: '/picklist-values',
    serviceUri: '/picklist-values',
    statusesFilterName: 'statuses',
    listingModuleName: 'Config',
    listingActivityName: 'View Pick List',
    formModuleName: 'Config',
    formActivityName: 'Edit Pick List',
    noEdit: true,
    showPicklistModal: false,
    picklistRowData: null,
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'value',
        title: 'VALUE',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'displayLabel',
        title: 'Display Label',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    resetPageFilters() {
      const store = usePickListsStore()
      store.resetBaseFilters()
    },
  },
  {}
)
